<template>
  <div class="extra-modal">
    <div class="modal--wrapper" :class="{'modal-open': modalOpenState}">
      <div class="modal modal-picture">
        <div class="modal--image">
          <img v-lazy="image + '?w=1920&h=1080&crop-to-fit'" >
          <a class="nav-btn next" @click="nextImage()" />
          <a class="nav-btn prev" @click="previousImage()" />
        </div>
        <div class="modal--title">
          <div class="modal--title-actions">
            <modal-close-btn @click="closeModal"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ModalCloseBtn from "./modal-close-btn";
  import Loader from "./loader.component";
  import {mapState} from "vuex";

  export default {
    name: "image-modal-slider",
    components: {Loader, ModalCloseBtn},
    async mounted() {
      window.addEventListener('app:image-modal-slider.open', () => {
        this.openModal();
      });
    },
    data() {
      return {
        modalOpenState: false,
       }
    },
    computed: {
      ...mapState({
        image: s => s.imageModal.imageArray[s.imageModal.arrayIndex],
        roomPicture: s => s.imageModal.imageArray,
        loading: s => s.room.loading,
        modalLoading: s => s.imageModal.loading,
        index: s => s.imageModal.arrayIndex
      }),

    },
    methods: {
      closeModal() {
        this.modalOpenState = false;
      },
      openModal() {
        this.modalOpenState = true;
      },
      nextImage() {
        this.$store.commit('imageModal/INCREMENT_INDEX');
      },
      previousImage() {
        this.$store.commit('imageModal/DECREMENT_INDEX')
      }
    },
  }
</script>

<style scoped>
  .modal {
    width: 90%;
  }

  .modal--title {
    padding: 0;
  }

  .modal .modal--image img {
    width: 100%;
    vertical-align: bottom;
  }

  .modal--image {
    height: calc(100% - 4px);
  }

  @media only screen and (max-width: 768px) {
    .modal {
      margin: auto;
      width: 90% !important;
      position: unset;
      bottom: unset;
      right: unset;
      left: unset;
    }

    .modal--title-actions {
      top: -24px;
      bottom: unset;
      right: 10px;
    }

    .modal {
      padding-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/image-modal-slider.vue